import _differenceWith from 'lodash-es/differenceWith';
import _isEqual from 'lodash-es/isEqual';
import { arrayToObject } from '../../../../helpers';
import {
  minStartDate,
  minStartTime,
} from '../../common/helpers/inputHandlers';

export const getGroupsData = (groups, programInfo) => {
  const formattedGroups = [];
  groups.forEach(group => {
    if (group?.can_plan_be_mapped && group?.active_employees > 0)
      formattedGroups.push({
        label: `${group?.group_name} (${group?.active_employees} employees)`,
        value: group?.group_id,
      });
  });

  const selectedGroupsFromData =
    programInfo?.groups_data?.map(group => ({
      label: `${group?.group_name} (${group?.active_employees} employees)`,
      value: group?.group_id,
    })) || [];

  const unSelectedGroupsFromData = _differenceWith(
    formattedGroups,
    selectedGroupsFromData,
    _isEqual,
  );

  return {
    selectedGroups: selectedGroupsFromData,
    unSelectedGroups: unSelectedGroupsFromData,
  };
};

export const createPlanFormData = (
  programInfo,
  selectedGroups,
  unSelectedGroups,
  selectedWorkspace,
  groups,
  currentFlow,
) => ({
  programId: programInfo?.id,
  selectedGroups,
  unSelectedGroups,
  showError: false,
  name: programInfo?.name || '',
  nameErrMsg: '',
  type: 1,
  workspaceID: selectedWorkspace?.workspace_id,
  startDate: programInfo?.start_date || minStartDate,
  startTime: programInfo?.start_time || minStartTime,
  endDate: programInfo?.end_date || '',
  groupIds: arrayToObject(groups, 'group_id'),
  neverEnd: programInfo?.never_ends ?? true,
  flowType: currentFlow,
});

export const createProgramBody = (selectedWorkspace, programId) => ({
  workspace_id: selectedWorkspace?.workspace_id || '',
  program_id: programId,
});

export const hasOptionsWithBuckets = programInfo =>
  programInfo?.option_details?.some(
    option => option.bucket && option.bucket.trim() !== '',
  );
